var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayerSoundOn24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Player/Audio24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconAudio",
    transform: "translate(4.000000, 4.000000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69230769,4 L8,0 L8,16 L3.69230769,12 L0,12 L0,4 L3.69230769,4 Z M10,10.4909091 C10.9343566,10.0370629 11.5832349,9.0972028 11.5832349,8 C11.5832349,6.9027972 10.9343566,5.96293706 10,5.50909091 L10,4 C11.7362456,4.52237762 13,6.11468531 13,8 C13,9.88461538 11.7362456,11.4776224 10,12 L10,10.4909091 Z M10,14.4128605 C12.61975,13.4770686 14.5,10.9632151 14.5,8 C14.5,5.03678487 12.61975,2.52293144 10,1.58713948 L10,0 C13.46125,0.988747045 16,4.19177305 16,8 C16,11.8074704 13.46125,15.011253 10,16 L10,14.4128605 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerSoundOn24);
export default __webpack_public_path__ + "static/media/playerSoundOn24.0f45356f188e7b8848a0c431c9f40f31.svg";
export { ForwardRef as ReactComponent };